// extracted by mini-css-extract-plugin
module.exports = {"card":"Company_card__1hAyR","logo":"Company_logo__1F2sQ","name":"Company_name__3362E","description":"Company_description__1TsEN"};